import store from "../../../_services/store";
import { BackButton, Image } from "../../_ui";
import labels from '../../../_translations/actualite.json';
import { useEffect } from "react";
import { ArrowContainer, Card, CardContainer, CardHeader, LabelDate, LabelName } from "./components";
import { displayDate } from "../../../_services/utils/utils";
import { ReactComponent as ArrowIcon } from '../../../assets/svg/right-arrow.svg';
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../router/routes";
import { observer } from "mobx-react";
import { useWindowResize } from "../../../_hooks/use-window-resize";

const NewsPage = observer(() => {
  const navigate = useNavigate();
  const { width } = useWindowResize();
  const currentWidth = width - 50;

  useEffect(() => {
    if (store.articles === null) {
      store.getArticles()
    }
  }, []);

  const openArticle = (id: string) => {
    navigate(ROUTES.ARTICLE(id));
  }

  const articles = store.articles?.map(article => {
    return (
      <Card key={`card_${article.title}`} onClick={() => openArticle(article.id.toString())} >
        <CardHeader>
          <Image style={{ borderRadius: '50%', maxWidth: `${currentWidth}px` }} src="/images/news2.jpeg" width="auto" height="100px" />
          <div style={{ maxWidth: `${currentWidth}px` }}>
            <LabelName>{article.title}</LabelName>
            <LabelDate>{displayDate(article.updated_at)}</LabelDate>
          </div>
        </CardHeader>
        <ArrowContainer>
          <ArrowIcon />
        </ArrowContainer>
      </Card>
    )
  })
  return (
    <div className="fadeIn">
      <BackButton title={labels[store.currentLanguage].labels.title} />
      <CardContainer>
        {articles}
      </CardContainer>
    </div>
  )
});

export default NewsPage;